import Cookies from 'js-cookie';

import { AUTHENTICATION_TOKEN } from 'common/constants';

/** Giá trị claim `scope` của token khách — khớp GuestConst.SCOPE_VALUE ở BE. */
export const GUEST_SCOPE = 'ganet.guest';

const decodePayload = (token: string): Record<string, unknown> | null => {
  const part = token.split('.')[1];
  if (!part) return null;
  // JWT dùng base64url: đổi -/_ về +// và bù '=' cho đủ block 4 ký tự, nếu không atob sẽ throw
  // với token có 2 ký tự đó (vd claim jti dạng UUID khi lên Duende) → khách bị coi là không phải khách.
  const b64 = part.replace(/-/g, '+').replace(/_/g, '/').padEnd(Math.ceil(part.length / 4) * 4, '=');
  return JSON.parse(atob(b64));
};

/**
 * True nếu token đang dùng là token KHÁCH. Đọc claim trực tiếp từ JWT (token là nguồn sự thật duy
 * nhất) nên khi BE chuyển sang Duende (client_credentials cũng mang scope này) không phải sửa gì.
 * Không dùng redux/localStorage để tránh lệch trạng thái sau khi refresh trang.
 */
export const isGuestToken = (): boolean => {
  const token = Cookies.get(AUTHENTICATION_TOKEN);
  if (!token) return false;
  try {
    const payload = decodePayload(token);
    return payload?.scope === GUEST_SCOPE;
  } catch {
    return false;
  }
};

/** Hook dùng trong component; token không đổi trong một phiên nên không cần state. */
const useIsGuest = (): boolean => isGuestToken();

export default useIsGuest;
